<template>
  <div class="banner">
    <div class="container">
      <div id="dealcards" class="columns is-centered">
        <div class="column is-4" v-for="(card, index) in cards" :key="index">
          <DealCard v-if="card.description && card.name" :deal="card" :website="website" />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import DealCard from "../atoms/DealCard.vue";
export default {
  components: {
    DealCard
  },
  data() {
    return {
    };
  },
  props: {
    cards: Array,
    website: {
      type: String,
      required: true,
    }
  }
};
</script>

<style scoped>

.active {
  height: 100vh
}

.banner{
  height: auto;
}


.columns {
  overflow: auto;
}
</style>